import type { AdminAgentPanelResize } from "../models/admin-agent.models";
import { ADMIN_AGENT_PANEL_ID } from "../utils/admin-agent.constants";

// Resize from the panel's left edge while keeping the admin page visible beside it.
const AdminAgentResizeHandle = ({ resize }: { resize: AdminAgentPanelResize }) => (
  <div
    role="separator"
    tabIndex={0}
    aria-label="Resize admin assistant"
    aria-orientation="vertical"
    aria-controls={ADMIN_AGENT_PANEL_ID}
    aria-valuemin={resize.minimumWidth}
    aria-valuemax={resize.maximumWidth}
    aria-valuenow={resize.width}
    aria-valuetext={`${resize.width} pixels`}
    title="Drag to resize, or use the left and right arrow keys"
    data-test="admin-agent-resize-handle"
    onPointerDown={resize.onPointerDown}
    onPointerMove={resize.onPointerMove}
    onPointerUp={resize.onPointerUp}
    onPointerCancel={resize.onPointerUp}
    onLostPointerCapture={resize.onPointerUp}
    onKeyDown={resize.onKeyDown}
    className={`absolute inset-y-0 left-0 z-10 flex w-2 -translate-x-1/2 cursor-col-resize touch-none select-none items-center justify-center focus-visible:bg-green/20 focus-visible:outline-none ${resize.isResizing ? "bg-green/20" : "hover:bg-green/20"}`}
  >
    <span className="h-12 w-1 rounded-full bg-gray-300 dark:bg-gray-600" aria-hidden="true" />
  </div>
);

export default AdminAgentResizeHandle;
